
import React from 'react';

const InterfacesBenefits = () => {
  const benefits = [
    {
      title: 'Automatisierter Datenaustausch',
      description: 'Eliminieren Sie manuelle Dateneingaben und die damit verbundenen Fehler durch automatisierten Datenaustausch zwischen Ihren Systemen.',
      icon: (
        <svg className="h-12 w-12 text-blue-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2"/>
          <path d="M15 12L12 12M12 12L9 12M12 12L12 9M12 12L12 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      )
    },
    {
      title: 'Höhere Datenqualität',
      description: 'Verbessern Sie die Konsistenz und Genauigkeit Ihrer Daten durch einheitliche Übertragung und Validierung über Systemgrenzen hinweg.',
      icon: (
        <svg className="h-12 w-12 text-blue-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Reduzierte Prozesskosten',
      description: 'Senken Sie operative Kosten durch optimierte Prozesse und vermeiden Sie Fehlerkosten durch manuelle Datenerfassung.',
      icon: (
        <svg className="h-12 w-12 text-blue-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Gesteigerte Geschwindigkeit',
      description: 'Beschleunigen Sie Ihre Geschäftsprozesse durch Echtzeit-Datenübertragung und unmittelbare Verfügbarkeit aktueller Informationen.',
      icon: (
        <svg className="h-12 w-12 text-blue-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13 10V3L4 14H11V21L20 10H13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Erhöhte Flexibilität',
      description: 'Reagieren Sie schneller auf Marktanforderungen durch flexible Integration neuer Systeme und Anpassung bestehender Prozesse.',
      icon: (
        <svg className="h-12 w-12 text-blue-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 13H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 17H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'Verbesserte Zusammenarbeit',
      description: 'Vereinfachen Sie die Zusammenarbeit mit Partnern, Lieferanten und Kunden durch standardisierte Datenaustauschprozesse.',
      icon: (
        <svg className="h-12 w-12 text-blue-700" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17 20H7C4 20 2 18 2 15V9C2 6 4 4 7 4H17C20 4 22 6 22 9V15C22 18 20 20 17 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M2 9H22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Vorteile professioneller Schnittstellenlösungen</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Durch die Integration Ihrer Systeme mit maßgeschneiderten Schnittstellen profitieren Sie von zahlreichen Verbesserungen in Ihrem Unternehmen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow duration-300">
              <div className="flex flex-col items-center mb-6">
                <div className="p-3 bg-blue-50 rounded-full mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 text-center">{benefit.title}</h3>
              </div>
              <p className="text-gray-600 text-center">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InterfacesBenefits;
